import { RoomSnapshot } from '../room/types';

export function FinishedScreen({ snapshot }: { snapshot: RoomSnapshot }) {
  const sorted = [...snapshot.players].sort((a, b) => b.score - a.score);
  const winner = sorted[0];

  return (
    <div className="app fade-in">
      <div style={{ fontSize: 28, color: 'var(--c-text-muted)' }}>
        Final
      </div>

      {winner && (
        <div className="center" style={{ flexDirection: 'column', gap: 16 }}>
          <div style={{ fontSize: 96 }}>🏆</div>
          <div style={{ fontSize: 56, fontWeight: 700 }}>{winner.displayName}</div>
          <div style={{ fontSize: 28, color: 'var(--c-accent)' }}>{winner.score} points</div>
        </div>
      )}

      <div className="spacer" />

      <div className="col">
        {sorted.map((p, idx) => (
          <div className="player-card" key={p.playerId}>
            <div className="avatar" aria-hidden>{idx + 1}</div>
            <div style={{ fontWeight: 600 }}>{p.displayName}</div>
            <div className="score">{p.score}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
